import React from 'react'
import useTitle from '../../hooks/useTitle'
import { RowSpacer } from 'common/components/Row'
import Button from 'common/components/Button'
import Icon from 'common/components/Icon'
import Text from 'common/components/Text'
import ShareButton from '../ShareButton/ShareButton'
import { useTranslation } from 'react-i18next'
import Toolbar from '../Toolbar'
import Page from 'app/components/Page'

export default ({ folder, sidebarShowing }) => {
  useTitle('title.folder', { folder: folder.name })
  const { t } = useTranslation()
  // const children = Object.values(folder.children || {})
  const toolbar = (
    <Toolbar>
      <Button>
        <Icon icon="folder" color={folder.color} />
        {!sidebarShowing && <Text>{folder.name}</Text>}
      </Button>

      <RowSpacer />

      <ShareButton item={folder}>{t('toolbar.view.share')}</ShareButton>
    </Toolbar>
  )

  return <Page title={folder.name} folderId={folder.id} toolbar={toolbar} />
}
